import { Link } from "react-router-dom";
import Card from "../components/common/Card";

export default function NotFoundPage() {
  return (
    <div className="auth-page">
      <Card>
        <h1 className="h1">Page not found</h1>
        <p className="muted">The page you requested does not exist.</p>
        <Link to="/dashboard">Go to dashboard</Link>
      </Card>
    </div>
  );
}
